import { checkLeadscoring } from './components/checkLeadscoring';

if (document.readyState !== 'loading') {
    initWidget();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initWidget();
    });
}

function initWidget() {
    // do what needs to be done
    checkLeadscoring();
}
